// MARK://dhk8/admin-shell/lib/queries/reservations
// Query tipada de reservas - F9.5 / ADR-0009. El Admin lee reservas por el grafo
// (pos-floor), tenant del JWT (RLS). Mismo campo `reservations` que ya consume el
// POS (apps/pos/src/lib/queries/floor.queries.ts).
// F9.17 / ADR-0008: escrituras también por el grafo (createReservation /
// updateReservation / cancelReservation). El tenantId lo pone el JWT (no va en input).
import { graphql } from '../../gql/index.js'

export const AdminReservationsQuery = graphql(`
  query AdminReservations($branchId: String, $date: String, $from: String, $to: String, $status: String) {
    reservations(branchId: $branchId, date: $date, from: $from, to: $to, status: $status) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`)

export const AdminCreateReservationMutation = graphql(`
  mutation AdminCreateReservation($input: PosCreateReservationInput!) {
    createReservation(input: $input) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`)

export const AdminUpdateReservationMutation = graphql(`
  mutation AdminUpdateReservation($id: ID!, $input: PosUpdateReservationInput!) {
    updateReservation(id: $id, input: $input) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`)

export const AdminCancelReservationMutation = graphql(`
  mutation AdminCancelReservation($id: ID!) {
    cancelReservation(id: $id) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`)
